import { UiDiscussionTab, UiDiscussion, TabState } from "../types/ui-discussion-tab";
import { CohortActions } from "../types/cohort-actions";
import { DiscussionActions, DiscussionCreateResult, DiscussionListResult } from "../types/discussion-actions";
import { cache5Mins } from "../utils/cache-utils";
import { DiscussionCommentActions } from "../types/discussion-comment-actions";

const initialState: UiDiscussionTab = {
    discussions: { fetching: false, lastFetched: null, discussionIds: [], discussions: []},
    myPosts: { fetching: false, lastFetched: null, discussionIds: [], discussions: []},
    pins: { fetching: false, lastFetched: null, discussionIds: [], discussions: []}
};

export function uiDiscussionTab(
    state: UiDiscussionTab = initialState,
    action: DiscussionActions | CohortActions | DiscussionCommentActions
): UiDiscussionTab {
    switch (action.type) {
        case 'cohorts/change-success':
            return resetTabState();

        case 'discussions/fetch-request':
            return { 
                ...state, 
                [action.tab]: {
                    ...state[action.tab],
                    fetching: true
                }
            };

        case 'discussions/fetch-success':
            return {
                ...state,
                [action.tab]: fetchSuccessState(action.data)
            }
            
        case 'discussions/fetch-error':
            return {
                ...state, 
                [action.tab]: {
                    ...state[action.tab],
                    fetching: false
                }
            }

        case 'discussions/loadmore-request':
            return {
                ...state,
                [action.tab]: {
                    ...state[action.tab],
                    fetching: true
                }
            }

        case 'discussions/loadmore-error':
            return {
                ...state,
                [action.tab]: {
                    ...state[action.tab],
                    fetching: false
                }
            }

        case 'discussions/loadmore-success':
            const discussion: UiDiscussion[] = action.data.result.map(x => {
                const d = action.data.entities.discussions![x];
                return {
                    id: d.id,
                    showAllComments: false,
                    commentsFetched: false,
                    commentsFetching: false,
                    readOnly: d.readonly
                };
            });
            if (discussion.length > 0) {
                return {
                    ...state,
                    [action.tab]: {
                        ...state[action.tab],
                        fetching: false,
                        discussionIds: [
                            ...state[action.tab].discussionIds,
                            ...action.data.result
                        ],
                        discussions: [...state[action.tab].discussions, ...discussion]
                    }
                };
            } else {
                return {
                    ...state,
                    [action.tab]: {
                        ...state[action.tab],
                        fetching: false,
                        allFetched: true
                    }
                };
            }

        case 'discussions/create-success':
            return {
                ...state,
                discussions: createDiscussionSuccess(state.discussions, action.data),
                myPosts: createDiscussionSuccess(state.myPosts, action.data)
            };

        case 'discussion-comments/fetch-request':
            const requestChange = { commentsFetching: true };
            return {
                ...state,
                discussions: updateDiscussionArray(
                    state.discussions,
                    action.discussionId,
                    requestChange
                ),
                myPosts: updateDiscussionArray(
                    state.myPosts,
                    action.discussionId,
                    requestChange
                ),
                pins: updateDiscussionArray(
                    state.pins,
                    action.discussionId,
                    requestChange
                )
            };

        case 'discussion-comments/fetch-success':
            const successChange = {
                commentsFetching: false,
                commentsFetched: true,
                showAllComments: true
            }
            return {
                ...state,
                discussions: updateDiscussionArray(
                    state.discussions,
                    action.discussionId,
                    successChange
                ),
                myPosts: updateDiscussionArray(
                    state.myPosts,
                    action.discussionId,
                    successChange
                ),
                pins: updateDiscussionArray(
                    state.pins,
                    action.discussionId,
                    successChange
                )
            };

        case 'discussion-comments/fetch-error':
            const errorChange = {
                commentsFetching: false
            }
            return {
                ...state,
                discussions: updateDiscussionArray(
                    state.discussions,
                    action.discussionId,
                    errorChange
                ),
                myPosts: updateDiscussionArray(
                    state.myPosts,
                    action.discussionId,
                    errorChange
                ),
                pins: updateDiscussionArray(
                    state.pins,
                    action.discussionId,
                    errorChange
                )
            };

        default:
            return state;
    }
}

export function resetTabState(): UiDiscussionTab {
    return initialState;
}

export function fetchSuccessState(data: DiscussionListResult) {
    const discussions: UiDiscussion[] = data.result.map(x => {
        const d = data.entities.discussions![x];
        return {
            id: d.id,
            showAllComments: false,
            commentsFetched: false,
            commentsFetching: false,
            readOnly: d.readonly
        };
    });
    return {
        fetching: false,
        lastFetched: cache5Mins(),
        discussions,
        discussionIds: data.result
    };
}

function updateDiscussionArray(
    tabState: TabState,
    discussionId: string,
    changes: { [id: string]: any }
) {
    return {
        ...tabState,
        discussions: tabState.discussions.map(x => {
            if (x.id !== discussionId) {
                return x;
            }
    
            return {
                ...x,
                ...changes
            };
        })
    }
}

function createDiscussionSuccess(
    tabState: TabState,
    data: DiscussionCreateResult
) {
    return {
        ...tabState,
        discussionIds: [data.result, ...tabState.discussionIds],
        discussions: [
            {
                id: data.result,
                showAllComments: false,
                commentsFetched: false,
                commentsFetching: false,
                readonly:false
            },
            ...tabState.discussions
        ]
    }
}